import { isNil } from 'lodash';
import { useViewTemplate, useViewTemplates } from '@shared/scenes/workflows/hooks';

export function useEntityFormViewTemplate({
  workflowTemplateId,
  viewTemplateId,
  type,
}: {
  workflowTemplateId?: string | null;
  viewTemplateId?: string | null;
  type: 'CREATE' | 'EDIT';
}) {
  // Further exploration here: https://app.shortcut.com/coast/story/46087/no-code-forms-refine-card-view-template-solution
  const { viewTemplates: cardViewTemplates } = useViewTemplates({
    workflowTemplateId,
    type: 'CARD',
    isPublic: false,
    skip: !isNil(viewTemplateId),
  });
  const { viewTemplate: queriedViewTemplate } = useViewTemplate(workflowTemplateId, viewTemplateId);

  return !isNil(viewTemplateId)
    ? queriedViewTemplate
    : cardViewTemplates.find(vt =>
        // not the best way to do this, see SC ticket linked above
        type === 'CREATE'
          ? vt.name.toLowerCase().startsWith('create ')
          : !vt.name.toLowerCase().startsWith('create '),
      ) ?? cardViewTemplates[0];
}
